import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { STColumn } from '@delon/abc/st';
import { SFSchema } from '@delon/form';
import { FilterGroup, FilterOperate, FilterOperateEntry, FilterRule, PageRequest } from '@shared/itcore/itcore.model';
import { AlainService } from '@shared/itcore/services/alain.service';
import { ItcoreSTColumn } from '@shared/itcore/services/alain.types';
import { itcoreService } from '@shared/itcore/services/itcore.service';
import { List } from 'linqts';
import { NzModalComponent } from 'ng-zorro-antd/modal';

@Component({
  selector: 'itcore-ad-search-modal',
  templateUrl: './modal.component.html',
  styles: [
    `
      .group-box {
        margin: 2px;
        padding: 3px;
        border: dashed 2px #ddd;
      }
      .group-box nz-select {
        margin-right: 5px;
      }
      .group-operate {
        margin: 3px 0;
      }
      .rule-box {
        margin: 3px 3px;
      }
      .rule-box nz-select,
      .rule-box nz-input-number,
      .rule-box input[nz-input],
      .rule-box nz-date-picker {
        width: 150px;
        float: left;
        margin-right: 8px;
      }
      .f-left {
        float: left;
      }
      .k-input {
        padding: 0;
        line-height: normal;
      }
    `,
  ],
})
export class AdSearchModalComponent implements OnInit {
  @Input() request: PageRequest;
  @Input() columns: ItcoreSTColumn[];
  @Input() title = '高级搜索';
  @Output() submited: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();
  @ViewChild('modal', { static: false }) modal: NzModalComponent;

  visible: boolean;
  group: FilterGroup;
  groupOperateEntries: FilterOperateEntry[] = [new FilterOperateEntry(FilterOperate.And), new FilterOperateEntry(FilterOperate.Or)];
  operateEntries: FilterOperateEntry[] = [];
  schemas: SFSchema[] = [];

  constructor(private itcore: itcoreService, private alain: AlainService) { }

  ngOnInit() {
    this.group = this.request.FilterGroup;
  }

  open() {
    if (!this.columns || !this.columns.length) {
      this.itcore.warning('列配置信息[columns]不存在，无法进行高级搜索');
      return;
    }
    this.columns = new List(this.columns).Where((m) => m.index && m.filterable).ToArray();
    this.modal.open();
  }

  close() {
    this.modal.close();
  }

  reset() {
    this.group.Groups = [];
    this.group.Rules = [];
    this.request.FilterGroup = new FilterGroup();
    this.submited.emit(this.request);
  }

  private copyGroup(g: FilterGroup) {
    const group = new FilterGroup();
    group.Operate = g.Operate;
    for (const item of g.Groups) {
      group.Groups.push(this.copyGroup(item));
    }
    for (const item of g.Rules) {
      group.Rules.push(new FilterRule(item.Field, item.Value, item.Operate));
    }
    return group;
  }

  submit() {
    const group = this.copyGroup(this.group);
    this.request.FilterGroup = group;
    this.submited.emit(this.request);
    this.close();
  }

  addGroup(group: FilterGroup) {
    const subGroup = new FilterGroup();
    subGroup.Level = group.Level + 1;
    group.Groups.push(subGroup);
  }
  removeGroup(group: FilterGroup, parentGroup: FilterGroup) {
    if (parentGroup) {
      const index = parentGroup.Groups.indexOf(group);
      if (index >= 0) {
        parentGroup.Groups.splice(index, 1);
      }
    }
  }

  addRule(group: FilterGroup) {
    const rule = new FilterRule(null, null);
    group.Rules.push(rule);
  }

  removeRule(rule: FilterRule, group: FilterGroup) {
    if (rule) {
      const index = group.Rules.indexOf(rule);
      if (index >= 0) {
        group.Rules.splice(index, 1);
      }
    }
  }

  fieldChange(field: string, rule: FilterRule) {
    const column: ItcoreSTColumn = this.columns.find((m) => m.index === field);
    if (!column) {
      return;
    }
    this.alain.changeFilterRuleType(rule, column);
  }
}
